import EditIcon from "@/assets/common/ic_edit.svg";
import SuccessIcon from "@/assets/common/ic_success_outline.svg?react";
import SuccessGrayIcon from "@/assets/common/ic_success_disable.svg?react";
import CloseIcon from "@/assets/common/ic_close_outline.svg?react";
import "./index.less";
import { useRef, useState } from "react";
import useClickOutSide from "@/utils/useClickOutSide";

interface EditInputProps {
  disabled?: boolean;
  initialValue: string;
  onDone: (value: string) => void;
}

const EditInput = (props: EditInputProps) => {
  const { disabled, initialValue, onDone } = props;
  const editInputRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState(initialValue);
  const [isEdit, setIsEdit] = useState(false);
  const isComposing = useRef(false);

  const handleFocus = () => {
    if(disabled) return;
    if (inputRef.current) {
      inputRef.current.focus();
    }
    setIsEdit(true);
  };

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    // 只有在非输入法组合状态下才过滤
    if (!isComposing.current) {
      const v = e.target.value.replace(/[^\d]/g, "");
      setValue(v);
    } else {
      setValue(e.target.value); // 组合中，原样保存
    }
  };

  const handleCancel = () => {
    setIsEdit(false);
    setValue(initialValue);
  };

  useClickOutSide(editInputRef, () => {
    handleCancel();
  });

  return (
    <div className={`edit-input ${isEdit ? "edit" : ""} ${disabled ? "disabled" : ""}`} ref={editInputRef}>
      <input
        disabled={!isEdit}
        ref={inputRef}
        type="text"
        placeholder="1-8位数字"
        value={value}
        onChange={handleInput}
        minLength={1}
        maxLength={8}
        className={`${!isEdit ? "disabled" : ""}`}
        onCompositionStart={() => { isComposing.current = true; }}
        onCompositionEnd={e => {
          isComposing.current = false;
          // 组合结束时再过滤
          const v = e.currentTarget.value.replace(/[^\d]/g, "");
          setValue(v);
        }}
      />
      {disabled ? null : !isEdit ? (
        <img onClick={handleFocus} src={EditIcon} className="icon"></img>
      ) : (
        <div className="icon-wrap">
          <CloseIcon
            className="icon"
            onClick={() => {
              handleCancel();
            }}
          />
          {value.length ? (
            <SuccessIcon
              className="icon"
              onClick={() => {
                onDone(value);
                setIsEdit(false);
              }}
            />
          ) : (
            <SuccessGrayIcon className="icon" />
          )}
        </div>
      )}
    </div>
  );
};

export default EditInput;
